var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGcs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 61,
    viewBox: "0 0 61 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.9319 22.6536L40.5828 18.8728L40.8261 17.2808C34.1732 11.016 23.5976 11.7263 17.6003 18.763C15.9344 20.7174 14.6985 23.154 14.0395 25.6701L15.3471 25.4793L22.6487 24.2324L23.2124 23.6353C26.4603 19.9413 31.952 19.4443 35.7021 22.5874L36.9319 22.6536Z",
    fill: "#EA4335"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7836 25.5588C44.9444 22.3585 43.2216 19.4815 40.8261 17.2808L35.7021 22.5872C37.8658 24.418 39.0984 27.1762 39.0455 30.0692V31.0111C41.5641 31.0111 43.606 33.1256 43.606 35.7337C43.606 38.3421 41.5641 40.4035 39.0455 40.4035H29.912L29.0153 41.4117V47.0763L29.912 47.9651H39.0455C45.5966 48.0179 50.9486 42.6141 50.9996 35.8299C51.0305 31.7178 49.0727 27.8627 45.7836 25.5588Z",
    fill: "#4285F4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7913 47.9654H29.912V40.4037H20.7913C20.1414 40.4035 19.5121 40.2589 18.9211 39.9792L17.6272 40.3904L13.9507 44.1713L13.6304 45.4581C15.6922 47.0703 18.2078 47.9769 20.7913 47.9654Z",
    fill: "#34A853"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7912 23.4364C14.24 23.4768 8.96117 29.0095 9.00022 35.7937C9.02204 39.5822 10.7306 43.1485 13.6304 45.458L18.9211 39.9791C16.6257 38.9052 15.6057 36.1077 16.6427 33.7308C17.6796 31.3538 20.3811 30.2975 22.6761 31.3713C23.6876 31.8445 24.4976 32.6835 24.9545 33.7308L30.2452 28.2519C27.9941 25.2044 24.4962 23.4226 20.7912 23.4364Z",
    fill: "#FBBC05"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGcs);
export default __webpack_public_path__ + "static/media/gcs.c85321c8697afb7e24bd8dcb6fb6ad1f.svg";
export { ForwardRef as ReactComponent };